import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import ProductFolioItemBuilderTabContent from "./ProductFolioItemBuilderTabContent";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import numeral from "numeral";
import { parseISO } from 'date-fns';
import TextConfirmation from "../ModalWarning/TextConfirmation";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import ModalWarning from "../ModalWarning/ModalWarning";


class ProductFolioItemBuilder extends React.Component {
  constructor(props) {
    super(props)

    let amount = null
    if (this.props.folio_item && this.props.folio_item.total_amount && this.props.folio_item.quantity)  {
      amount = (this.props.folio_item.total_amount / this.props.folio_item.quantity)
    } else if (this.props.folio_item && this.props.folio_item.total_amount) {
      amount = this.props.folio_item.total_amount
    }

    this.state = {
      edit: this.props.edit,
      errors: [],
      active_tab: this.props.active_tab || 'folio-item-general',
      displayWarningModal: false,
      date_range: false,
      date_range_open: false,
      start_date: null,
      end_date: null,
      tabs: true,
      amount: amount,
      notes: '',
      product: this.props.folio_item && this.props.folio_item ? this.props.folio_item.product : null,
      quantity: this.props.folio_item && this.props.folio_item.quantity ? this.props.folio_item.quantity : 1,
      item_date: this.props.folio_item.item_date ? parseISO(this.props.folio_item.item_date) : new Date(),
      item_type: this.props.folio_item.folio_item_type_name || null,
      room_type: this.props.reservation_segment && this.props.reservation_segment.room_type ? this.props.reservation_segment.room_type : null,
      check_in_date: this.props.reservation_segment && this.props.reservation_segment.check_in_date ? this.props.reservation_segment.check_in_date : null,
      check_out_date: this.props.reservation_segment && this.props.reservation_segment.check_out_date ? this.props.reservation_segment.check_out_date : null,
      rate: this.props.folio_item.rate || null,
      cancellation_rule: this.props.folio_item.cancellation_rule ? this.props.folio_item.cancellation_rule : null,
      guest_type: this.props.guest_type ? this.props.guest_type : null,
      fee: this.props.folio_item.fee ? this.props.folio_item.fee : null,
      tax: this.props.folio_item.tax ? this.props.folio_item.tax : null,
      calculate_taxes_and_fees: false,
      folio: this.props.folio,
      displayConfirmToSave: false,
      submitTextConfirmed: false, 
      submitCheckboxConfirmed: false,
      total_with_taxes: this.props.folio_item && this.props.folio_item.total_amount_with_taxes ? this.props.folio_item.total_amount_with_taxes : null,
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      image_group: this.props.image_group,
      taxes: this.getTaxes().taxes,
      tax_ids: this.getTaxes().tax_ids,
      fees: this.getFees().fees,
      fee_ids: this.getFees().fee_ids
    }
    this.onSave = this.onSave.bind(this);
    this.warningModalBody = this.warningModalBody.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeAmount = this.onChangeAmount.bind(this);
    this.onChangeProduct = this.onChangeProduct.bind(this);
    this.onChangeItemDate = this.onChangeItemDate.bind(this);
    this.onChangeTaxes = this.onChangeTaxes.bind(this);
    this.onChangeFees = this.onChangeFees.bind(this);
    this.onChangeFolio = this.onChangeFolio.bind(this);
    this.onChangeNote= this.onChangeNote.bind(this);
    this.onChangeImageGroup = this.onChangeImageGroup.bind(this);
    this.onChangeFlagged = this.onChangeFlagged.bind(this);
    this.onChangeQuantity = this.onChangeQuantity.bind(this);
    this.onChangeRate = this.onChangeRate.bind(this);
    this.onChangeCancellationRule = this.onChangeCancellationRule.bind(this);
    this.onChangeGuestType = this.onChangeGuestType.bind(this);
    this.onChangeFee = this.onChangeFee.bind(this);
    this.onChangeItemType = this.onChangeItemType.bind(this);
    this.onChangeCalculateTaxesAndFees = this.onChangeCalculateTaxesAndFees.bind(this);
    this.onChangeDates = this.onChangeDates.bind(this);
    this.onChangeDateRange = this.onChangeDateRange.bind(this);
  }

  render() {
    var self = this;
    if (this.state.calculate_taxes_and_fees) {
      var buttons = [
        {
          name: I18n.t('cancel'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary'],
          html_attributes: this.state.date_range_open ? ["disabled"] : [],
          onClick: function (e) {
            e.stopPropagation()
            e.preventDefault()
            self.setState({
              displayWarningModal: true,
            })
          }
        }
      ]
    } else {
      var buttons = [
        {
          name: I18n.t('cancel'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary'],
          html_attributes: this.state.date_range_open ? ["disabled"] : [],
          onClick: function (e) {
            e.stopPropagation()
            e.preventDefault()
  
            self.onSave()
          }
        }
      ]
    }
  

    return (
        <div className="product-folio-item-builder" ref="root">
          <Tabs tabs={this.tabs()} edit_booking={this.props.edit_booking} />
          <div className="panel panel-form">
            <ProductFolioItemBuilderTabContent {...this.state}
              edit_booking={this.props.edit_booking}
              date_format={this.props.date_format}
              all_cancellation_rules={this.props.all_cancellation_rules}
              add_charge_rates_remote_path={this.props.add_charge_rates_remote_path}
              all_guest_types={this.props.all_guest_types}
              all_fees={this.props.all_fees}
              calculate_children_data_table_path={this.props.calculate_children_data_table_path}
              room_revenue={this.props.room_revenue || null}
              cancellation_fee={this.props.cancellation_fee || null}
              fee_type={this.props.fee_type || null}
              guest_fee={this.props.guest_fee || null}
              reservation_segment={this.props.reservation_segment}
              buttons={buttons}
              time_format={this.props.time_format}
              dateFormat={this.props.date_format}
              onChangeItemDate={this.onChangeItemDate}
              onChangeAmount={this.onChangeAmount}
              onChangeQuantity={this.onChangeQuantity}
              onChangeProduct={this.onChangeProduct}
              onChangeFolio={this.onChangeFolio}
              onChangeTaxes={this.onChangeTaxes}
              onChangeFees={this.onChangeFees}
              onChangeStatus={this.onChangeStatus}
              onChangeNote={this.onChangeNote}
              onChangeImageGroup={this.onChangeImageGroup}
              onChangeFlagged={this.onChangeFlagged}
              onChangeItemType={this.onChangeItemType}
              onChangeRate={this.onChangeRate}
              onChangeCancellationRule={this.onChangeCancellationRule}
              onChangeGuestType={this.onChangeGuestType}
              onChangeFee={this.onChangeFee}
              onChangeCalculateTaxesAndFees={this.onChangeCalculateTaxesAndFees}
              onChangeDateRange={this.onChangeDateRange}
              onChangeDates={this.onChangeDates}
              setDateRangePickerVisibility={this.setDateRangePickerVisibility}
             />

          </div>
          {this.renderTotal()}
          {this.state.displayWarningModal ? (
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("post_date_warning")}
                body={this.warningModalBody()}
                CancelSubmit={true}
                onSubmit={this.onSave}
                onCancel={() => this.setState({ displayWarningModal: false})}
              />
            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        ) : null}
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <LoadingSpinner show={this.state.loading} />
        </div>
    );

  };

  tabs(){
    if( this.props.edit_booking ) {
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'folio-item-general',
            classes: this.state.active_tab === 'folio-item-general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          // {
          //   tabName: I18n.t('taxes_and_fees'),
          //   targetName: 'taxes_and_fees',
          //   classes: this.state.active_tab === 'taxes_and_fees' ? 'active' : null,
          //   changeHandler: this.onChangeActiveTab,
          // },
        ]
      )
    } else {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'folio-item-general',
            classes: this.state.active_tab === 'folio-item-general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          // {
          //   tabName: I18n.t('taxes_and_fees'),
          //   targetName: 'taxes_and_fees',
          //   classes: this.state.active_tab === 'taxes_and_fees' ? 'active' : null,
          //   changeHandler: this.onChangeActiveTab,
          // },
          {
            tabName: I18n.t('notes'),
            targetName: 'folio-item-notes',
            classes: this.state.active_tab === 'folio-item-notes' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      );
    };
  };

  warningModalBody() {
    return (
      <div className="modal-body">
        <div className="alert alert-warning" style={{ marginBottom: 0 }} role="alert">
          {I18n.t('post_date_warning_text')}
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  onConfirmText = (value) => {
    this.setState({
      submitTextConfirmed: value
    });
  };

  onConfirmCheckbox = (value) => {
    this.setState({
      submitCheckboxConfirmed: value
    });
  };

  activeWarningModalButtons = () => {
    if (this.state.submitTextConfirmed && this.state.submitCheckboxConfirmed) {
      return false;
    } else {
      return true;
    };
  };

  renderTotal() {
    if (this.state.total_with_taxes && this.state.total_with_taxes != 0) {
      return (
        <div className="accommodations-price-footer">
          <p className="lead" style={{marginBottom: 0}}>
            <label style={{marginBottom: 0}}>{I18n.t('total_with_taxes')}:</label>&nbsp;
            {this.formatCurrency(this.state.total_with_taxes)}
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  getTaxes() {
    let taxes
    let tax_ids
    if (this.props.fee_type) {
      taxes = this.props.folio_item.fee_taxes ? this.props.folio_item.fee_taxes : []
      tax_ids = this.props.folio_item.fee_taxes && this.props.folio_item.fee_taxes.length ? this.props.folio_item.fee_taxes.map((tax) => { return tax.id}) : []
    } else if (!this.props.room_revenue && !this.props.cancellation_fee) {
      taxes = this.props.folio_item.product_taxes ? this.props.folio_item.product_taxes : []
      tax_ids = this.props.folio_item.product_taxes && this.props.folio_item.product_taxes.length ? this.props.folio_item.product_taxes.map((tax) => { return tax.id}) : []
    } else if (this.props.room_revenue || this.props.cancellation_fee) {
      taxes = this.props.folio_item.rate_taxes ? this.props.folio_item.rate_taxes : []
      tax_ids = this.props.folio_item.rate_taxes && this.props.folio_item.rate_taxes.length ? this.props.folio_item.rate_taxes.map((tax) => { return tax.id}) : []
    } 
;
    return ({
      taxes: taxes,
      tax_ids: tax_ids,
    });
  };

  getFees() {
    let fees
    let fee_ids
    
    if (!this.props.room_revenue) {
      fees = this.props.product_fees ? this.props.product_fees : []
      fee_ids = this.props.product_fees && this.props.product_fees.length ? this.props.product_fees.map((fee) => { return fee.id}) : []
    } else if (this.props.room_revenue) {
      fees = this.props.rate && this.props.rate.fees ? this.props.rate.fees : []
      fee_ids = this.props.rate && this.props.rate.fees.length ? this.props.rate.fees.map((fee) => { return fee.id}) : []
    }
    return({
      fees: fees,
      fee_ids: fee_ids,
    });
  };

  calculatePrice() {
    var self = this;
    self.setState({loading: true})
    $.ajax({
      type: 'POST',
      url: self.props.calculate_price_path,
      data: {
        folio_item: {
          subtotal: self.state.amount,
          total_amount: self.state.amount * self.state.quantity,
          folio_id: self.state.folio ? self.state.folio.id : null,
          item_date: self.state.item_date,
          product_id: self.state.product ? self.state.product.id : null,
          rate_id: self.state.rate ? self.state.rate.id : null,
          guest_type_id: self.state.guest_type ? self.state.guest_type.id : null,
          quantity: self.state.quantity,
          rate_id: self.state.rate ? self.state.rate.id : null,
          fee_id: self.state.fee ? self.state.fee.id : null,
          room_type_id: self.state.room_type ? self.state.room_type.id : null,
        },
        start_date: self.state.start_date,
        end_date: self.state.end_date,
        date_range: self.state.date_range,

        session_id: self.props.folio_item.session_id ? self.props.folio_item.session_id : null,
        item_type: self.state.item_type,
        segment_temp_id: self.props.segment_temp_id ? self.props.segment_temp_id : null,
        tax_ids: self.state.tax_ids,
        fee_ids: self.state.fee_ids,
        calculate_taxes_and_fees: self.state.calculate_taxes_and_fees ? "inclusive" : "exclusive",
      }
    }).done(function(data) {
      $(window).trigger('refresh_data_table');

      if(data && data.errors && data.errors.length != 0) {
      } else {
        self.setState({
          // amount: data.folio_item.total_amount,
          loading: false,
          total_with_taxes: data.folio_item.total_amount_with_taxes,
        })
      }

    })
  }

  onSave() {
    var self = this;

    self.setState({loading: true})
  
    $.ajax({
      type: !self.props.new_record ? 'PATCH' : 'POST',
      url: self.props.form_action,
      data: {
        // update reservation_segment params
        folio_item: {
          subtotal: self.state.amount,
          total_amount: self.state.amount * self.state.quantity,
          folio_id: self.state.folio ? self.state.folio.id : null,
          item_date: self.state.item_date,
          product_id: self.state.product ? self.state.product.id : null,
          quantity: self.state.quantity,
          rate_id: self.state.rate ? self.state.rate.id : null,
          guest_type_id: self.state.guest_type ? self.state.guest_type.id : null,
          room_type_id: self.state.room_type ? self.state.room_type.id : null,
          fee_id: self.state.fee ? self.state.fee.id : null,
          tax_id: self.state.tax ? self.state.tax.id : null,
          cancellation_rule_id: self.state.cancellation_rule ? self.state.cancellation_rule.id : null,

          // discount_amount: discount_amount,
        },
        start_date: self.state.start_date,
        end_date: self.state.end_date,
        date_range: self.state.date_range,
        session_id: self.props.folio_item.session_id ? self.props.folio_item.session_id : null,
        segment_temp_id: self.props.segment_temp_id ? self.props.segment_temp_id : null,
        calculate_taxes_and_fees: self.state.calculate_taxes_and_fees ? "inclusive" : "exclusive",
        item_type: self.state.item_type,
        tax_ids: self.state.tax_ids,
        fee_ids: self.state.fee_ids,
        note: self.state.note_obj,
        image_group_images: self.state.image_group && self.state.image_group.images ? self.state.image_group.images.map(function (image) { return image.id; }) : null,
      },
    }).done((data) =>{
      // console.log("data", data);
      if (data && data.errors) {
        self.setState({
          errors: data.errors,
          loading: false,
        })
      } else if (data && data.success) {
        self.setState({loading: false})

        // debugger
        // $(parent.window).trigger('refresh_folios_table')
        if( data && parent && parent.refresh_data) {
          if (self.props.new_record == true) {
            // console.log("data has came back");
            parent.refresh_data(I18n.t('folio_item_saved_successfully'));

          } else {
            parent.refresh_data(I18n.t('folio_item_saved_successfully'));
          }

        }

        if(parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    })
  }

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  };

  onChangeDateRange(date_range) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
  
    this.setState({
      date_range: date_range,
      start_date: date_range ? today : null,
      end_date: date_range ? tomorrow : null
    }, () => {
      this.updateTotal();
    });
  }

  onChangeTaxes(newTaxes) {
		this.setState({
      tax_ids: newTaxes ? newTaxes : [],
    }, () => {
      this.updateTotal()
    })
	}

  onChangeFees(newFees) {
    this.setState({
      fee_ids: newFees ? newFees : [],
    }, () => {
      this.updateTotal()
    })
  }

  onChangeItemDate(date) {
      this.setState({
        item_date: date,
      })
  }

  setDateRangePickerVisibility = (visible) =>{
    if (this.state.date_range_open != visible) {
      this.setState({date_range_open: visible})
    };
  }

  onChangeFolio(folio) {
    this.setState({
      folio: folio,
    })
  }

  onChangeDates(start_date, end_date) {
    var self = this;
   
    this.setState(
      {
        start_date: new Date(start_date),
        end_date: new Date(end_date),
      }, () => {
        this.updateTotal()
      }
    );
    
  }

  onChangeAmount = (e) => {
    var str = e.target.value.replace(/,/g, "")


    this.setState({
      amount: parseInt((str * 100).toFixed(0)),
    }, () => {
      this.updateTotal()
    })
  }

  onChangeQuantity(e) {
    this.setState({
      quantity: e.target.value,
    }, () => {
      this.updateTotal()
    })
  }

  updateTotal() {
    this.calculatePrice()
  }

  onChangeProduct(product) {
    if (product) {
      this.setState({
        product: product,
        amount: product.amount,
        taxes: product.taxes,
        tax_ids: product.taxes && product.taxes.length ? product.taxes.map((tax) => {return tax.id}) : [],
        fees: product.fees,
        fee_ids: product.fees && product.fees.length ? product.fees.map((fee) => {return fee.id}) : [],
      }, () => this.updateTotal())
    }
  }


  onChangeImageGroup(image_group) {
    this.setState({image_group: image_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }


  onChangeFlagged(event) {
    // console.log("onChangeFlagged", event);
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = event.target.checked
    this.setState({note_obj: note_obj});
  }


  onChangeRate(rate) {
    var self = this;
    this.setState({
      rate: rate,
      item_type: "lodging",
      amount: rate.amount_for_date,
      taxes: rate.taxes,
      tax_ids: rate.taxes && rate.taxes.length ? rate.taxes.map((tax) => {return tax.id}) : [],
    }, () => this.updateTotal())
  }

  onChangeItemType(item_type) {
    var self = this;
    let type = item_type.text;
      this.setState({
        amount: null,
        quantity: 1,
        item_type: type,
        taxes: self.props.lodging_taxes,
        tax_ids: self.props.lodging_taxes && self.props.lodging_taxes.length ? self.props.lodging_taxes.map((tax) => {return tax.id}) : [],
        total_with_taxes: null,
      })

  }

  onChangeGuestType(guest_type) {
    var guestType = {id: guest_type.id, name: guest_type.text}
    var guest = null
    this.props.all_guest_types.map((gt) => {
      if (gt.id === guest_type.id) {
        guest = gt
      }
    })

    this.setState(
      {
        guest_type: guestType,
        taxes: guest.taxes,
        tax_ids: guest.taxes && guest.taxes.length ? guest.taxes.map((tax) => {return tax.id} ) : null,
        amount: guest.amount ? guest.amount : null,
        item_type: 'guest_fee',
      }, () => this.updateTotal()
    )
  }

  onChangeFee(fee) {
    var amount = null
    if (this.props.folio_item.fee && this.props.folio_item.fee.id == fee.id && this.props.folio_item.total_amount) {
      var amount = this.props.folio_item.total_amount
    }
    var fee1 = {id: fee.id, name: fee.text}
    var fee2 = null
    this.props.all_fees.map((f) => {
      if (f.id === fee.id) {
        fee2 = f
      }
    })

    this.setState(
      {
        fee: fee1,
        taxes: fee2.taxes,
        tax_ids: fee2.taxes && fee2.taxes.length ? fee2.taxes.map((tax) => {return tax.id} ) : null,
        amount: amount,
        item_type: 'fee',
      }, () => this.updateTotal()
    )
  }



  onChangeCancellationRule(cancellation_rule) {
    var cancellationRule = {id: cancellation_rule.id, name: cancellation_rule.text}
    var cancel = null
    this.props.all_cancellation_rules.map((cr) => {
      if (cr.id === cancellation_rule.id) {
        cancel = cr
      }
    })
    this.setState(
      {
        cancellation_rule: cancellationRule,
        taxes: cancel.taxes,
        tax_ids: cancel.taxes && cancel.taxes.length ? cancel.taxes.map((tax) => {return tax.id} ) : null,
        amount: cancel.amount ? cancel.amount : null,
        rate: this.props.reservation_segment.rate,
        item_type: 'cancellation',
      }, () => this.updateTotal()
    )
  }

  onChangeCalculateTaxesAndFees(e) {
    var state = Object.assign({}, this.state.calculate_taxes_and_fees)
    var value = e.target.checked ? 'inclusive' : 'exclusive';
    if (value === 'inclusive') {
        state = true
    } else {
      state = false
    }
    this.setState({calculate_taxes_and_fees: state}, () => this.updateTotal())
  }

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }

}

export default ProductFolioItemBuilder
